import { render, staticRenderFns } from "./BaseVoteButton.vue?vue&type=template&id=fc80870e"
import script from "./BaseVoteButton.vue?vue&type=script&lang=js"
export * from "./BaseVoteButton.vue?vue&type=script&lang=js"
import style0 from "./BaseVoteButton.vue?vue&type=style&index=0&id=fc80870e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports